export default "__VITE_ASSET__ed759225__"